<template>
  <div id="eventList" v-if="renderComponent">
    <sideBar :isChange="isChange" />

    <div class="mobile-event-header-container" v-if="checkMobileStatus">
      <h4>{{ lang('Event') }}</h4>
    </div>

    <div
      class="content-body-container"
      :class="
        schoolID === 'SCH201400000480' ||
        schoolID === 'SCH201400000497' ||
        schoolID === 'SCH201400000501' ||
        schoolID === 'SCH201400000510' ||
        schoolID === 'SCH201500000032' ||
        schoolID === 'SCH201500000054' ||
        schoolID === 'SCH201500000074' ||
        schoolID === 'SCH201400000541' ||
        schoolID === 'SCH201400000553' ||
        schoolID === 'SCH201400000471' ||
        (isParent === 'Parent' && parentSchIds.includes('SCH201400000480'))
          ? 'col-md-8'
          : 'col-md-11'
      "
    >
      <eventCom />
    </div>
  </div>
</template>

<script>
'use strict'
import DataSource from '../data/datasource'

import sideBar from '../components/Sidebar'
import eventCom from '../pages/Event'
import { lang } from '../locale/index'
import $ from 'jquery'
import Cookies from 'js-cookie'

export default {
  name: 'NewEvent',
  components: {
    sideBar,
    eventCom,
  },
  data() {
    return {
      renderComponent: true,
      isChange: false,
      checkMobileStatus: false,
      schoolID: '',
      isParent: '',
      parentSchIds: [],
    }
  },
  methods: {
    lang,
    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    $(window).unbind('scroll')
    window.removeEventListener('resize', this.isMobile)
  },
  mounted() {
    const self = this
    self.isMobile()

    $(document).ready(function () {
      $('.content-body-container').css('min-height', window.outerHeight)
      $('.sideBarSection__item').appendTo('.sidebar-action-container .action-body')
    })

    this.schoolID = Cookies.get('schoolSession')
    this.isParent = Cookies.get('userTypeSession')

    if (this.isParent === 'Parent') {
      this.schoolIDs = JSON.parse(this.schoolID)
      this.schoolIDs = this.schoolIDs.Table

      this.parentSchIds = []
      this.schoolIDs.forEach((object, index) => {
        this.parentSchIds.push(object.SCH_Ids)
      })
    }
  },
}
</script>

<style scoped>
.content-body-container {
  display: inline-block;
  padding: 20px;
  background: white;
}

.mobile-event-header-container {
  text-align: center;
  border-radius: 4px 4px 0px 0px;
  padding: 10px 0px;
  margin: 0px;
  background: #3c3956;
  min-height: unset !important;
  color: white;
}
</style>
